/* Trim the embedded page's trailing margin; Bubblehouse owns frame sizing. */
(function () {
  'use strict';

  var frame = document.getElementById('bubblehouse-page');
  if (!frame) return;

  function applyRewardsSpacing() {
    try {
      var doc = frame.contentDocument;
      if (!doc || !doc.head || doc.getElementById('fizzy-rewards-spacing')) return;

      var style = doc.createElement('style');
      style.id = 'fizzy-rewards-spacing';
      style.textContent = '#refer.refer__wrapper { margin-bottom: 0 !important; }';
      doc.head.appendChild(style);
    } catch (error) {
      // A future cross-origin app redirect must not interrupt the rewards page.
    }
  }

  frame.addEventListener('load', applyRewardsSpacing);
  applyRewardsSpacing();
})();
